export default "__VITE_ASSET__Nc6CFk0f__"